module.exports = __webpack_public_path__ + "static/media/CountryIso3Code.ffe89ccd.csv";